import Vue from 'vue';  
export default new Vue({
  data: {
    _this: null,
    homeInfo: null
  }
});


// WEBPACK FOOTER //
// ./src/utils/bus.js